module.exports = __webpack_public_path__ + "img/humidity.c505b7ba.png";